let actions = require("./actions");
let store = require("./store");

let seconds;

let resetTimer = () => {
  seconds = window.AUTO_LOGOUT_SECONDS || 1800;
};

resetTimer();

setInterval(() => {
  let state = store.getState();

  if (state.user && !state.prefs.stayLoggedIn) {
    seconds--;

    if (seconds <= 30) {
      mc.ui.alert(tx("logging_out", { seconds }), {
        labels: {
          confirm: tx("stay_logged_in")
        },
        onHide: function (confirmed) {
          if (confirmed) {
            resetTimer();
          }
        }
      });
    }

    if (seconds === 0) {
      actions.logout().then(() => {
        mc.router.trigger("LOGIN_VIEW");
        resetTimer();
      });
    }
  }
}, 1000);

document.addEventListener("click", () => {
  if (seconds > 30) {
    resetTimer();
  }
});
